import { useEffect, useRef } from "react";
import gsap from "gsap";
import FloatingElement from "./animations/FloatingElement";
import { ChevronDown } from "lucide-react";
import "./simpleHero.css";

const SimpleHeroSection = ({
  title,
  tagline,
  showScrollCue = true,
}) => {
  const heroRef = useRef(null);
  const titleRef = useRef(null);
  const taglineRef = useRef(null);
  const scrollCueRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({ delay: 0.4 });

    // Split text animation
    const titleText = titleRef.current;
    const text = titleText.textContent;
    titleText.innerHTML = "";

    text.split("").forEach((char) => {
      const span = document.createElement("span");
      span.textContent = char === " " ? "\u00A0" : char;
      span.style.display = "inline-block";
      span.style.opacity = "0";
      titleText.appendChild(span);
    });

    timeline
      .to(titleRef.current.children, {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.04,
        ease: "power3.out",
      })
      .fromTo(
        taglineRef.current,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, ease: "power3.out" },
        "-=0.5"
      )
      .fromTo(
        scrollCueRef.current,
        { opacity: 0 },
        { opacity: 1, duration: 0.4 },
        "-=0.2"
      );

    gsap.to(scrollCueRef.current, {
      y: 10,
      duration: 1.5,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
    });

    return () => timeline.kill();
  }, []);

  return (
    <section ref={heroRef} className="hero-section">
      <div className="hero-background">
        <FloatingElement duration={4} yOffset={25} xOffset={15}>
          <div className="hero-shape hero-shape-1" />
        </FloatingElement>
        <FloatingElement duration={5} yOffset={-20} xOffset={-10}>
          <div className="hero-shape hero-shape-2" />
        </FloatingElement>
      </div>

      <div className="hero-content">
        <h1 ref={titleRef} className="hero-title">
          {title}
        </h1>
        <p ref={taglineRef} className="hero-tagline">
          {tagline}
        </p>
      </div>

      {showScrollCue && (
        <div ref={scrollCueRef} className="scroll-cue">
          <span>Scroll</span>
          <ChevronDown size={20} />
        </div>
      )}
    </section>
  );
};

export default SimpleHeroSection;